import {IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IExportTask extends IBaseEntity {
    id?: number;
    exportTaskType?: string;
    exportTaskStatus?: string;
    data?: string;
    lastProcessedOn?: string;
    retriesLeft?: number;
    error?: string;
    createDate?: string;
    immediateProcessing?: boolean;
    createdById?: number;
}

export class ExportTask implements IExportTask {
    id?: number;
    exportTaskType?: string;
    exportTaskStatus?: string;
    data?: string;
    lastProcessedOn?: string;
    retriesLeft?: number;
    error?: string;
    createDate?: string;
    immediateProcessing?: boolean;
    createdById?: number;

    constructor(obj?: any) {
        if (obj) {
            this.id = obj.id;
            this.exportTaskType = obj.exportTaskType;
            this.exportTaskStatus = obj.exportTaskStatus;
            this.data = obj.data;
            this.lastProcessedOn = obj.lastProcessedOn;
            this.retriesLeft = obj.retriesLeft;
            this.error = obj.error;
            this.createDate = obj.createDate;
            this.immediateProcessing = obj.immediateProcessing;
            this.createdById = obj.createdById;
        }
    }

    discriminator?: any;
    toFormObject() {
        throw new Error('Method not implemented.');
    }
    clone(): IBaseEntity {
        return new ExportTask(this);
    }
}
